// bounding box anchor size
export const TRANSFORMER_ANCHOR_SIZE = 15;

// canvas wheel zoom exponential scale factor
export const CANVAS_SCALE_BY = 0.999;

// minimum (furthest-zoomed-out) scale
export const MIN_CANVAS_SCALE = 0.1;

// maximum (furthest-zoomed-in) scale
export const MAX_CANVAS_SCALE = 20;

// padding given to initial image/bounding box when stage view is reset
export const STAGE_PADDING_PERCENTAGE = 0.95;

export const COLOR_PICKER_SIZE = 30;
export const COLOR_PICKER_STROKE_RADIUS = 10;
